import React, { useState, useEffect } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { FiUser, FiSave, FiX, FiCheckCircle, FiAlertCircle } from "react-icons/fi";
import "./ProfileModal.css";

const ProfileModal = ({ isOpen, onClose }) => {
  const { user, updateProfile } = useAuth();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  // Sync form with the current user (handles both system + company shapes)
  useEffect(() => {
    if (!user) return;
    setFormData({
      name: user.name || user.Usercomp_sure_name || "",
      email: user.email || user.Usercomp_email || "",
      password: "",
    });
  }, [user]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError("");
    setSuccess("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    const result = await updateProfile({
      name: formData.name,
      email: formData.email,
      password: formData.password,
    });

    if (result.success) {
      setSuccess("Profile updated successfully");

      // auto-close after a short success flash
      setTimeout(() => {
        setSuccess("");
        onClose();
      }, 1200);
    } else {
      setError(result.error || "Update failed. Please try again.");
    }

    setLoading(false);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <FiUser className="modal-header-icon" />
          <h3>Edit Profile</h3>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          <label>Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter your name"
            required
          />

          <label>Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter your email"
            required
          />

          <label>Password (leave blank to keep current)</label>
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            placeholder="Enter new password"
          />

          {success && (
            <div className="modal-feedback success">
              <FiCheckCircle size={16} />
              {success}
            </div>
          )}

          {error && (
            <div className="modal-feedback error">
              <FiAlertCircle size={16} />
              {error}
            </div>
          )}

          <div className="modal-actions">
            <button type="submit" className="btn-save" disabled={loading}>
              {loading ? "Saving..." : (<><FiSave /> Save</>)}
            </button>
            <button type="button" className="btn-cancel" onClick={onClose}>
              <FiX /> Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ProfileModal;